import { render, staticRenderFns } from "./SimCardSWAP.vue?vue&type=template&id=60be3763&scoped=true&"
import script from "./SimCardSWAP.vue?vue&type=script&lang=js&"
export * from "./SimCardSWAP.vue?vue&type=script&lang=js&"
import style0 from "./SimCardSWAP.vue?vue&type=style&index=0&id=60be3763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be3763",
  null
  
)

export default component.exports